import { OvForm, OvFormInput, OvFormProvider } from '@components'
import { HELPER_TEXT, PLACEHOLDERS, TOOLTIPS } from '@constants'
import { useStore } from '@hooks/useStore'
import { Button, Stack, Tooltip } from '@mui/material'
import { ISingleClientContact } from '@typings'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { clientContactValidationSchema } from './validation/client-contact.form.validation'

export interface IClientContactUpdateForm {
  contactId: ISingleClientContact['id']
}

export const ClientContactUpdateForm = observer(({ contactId }: IClientContactUpdateForm) => {
  const { client, ui } = useStore()
  const getDefaultValues = useCallback(() => client.getSingleClientContact(contactId), [contactId])

  const form = useForm({
    resolver: yupResolver(clientContactValidationSchema()),
    defaultValues: getDefaultValues,
    mode: 'onChange',
  })

  const onSubmitCallBack = useCallback(
    (data: FieldValues) => {
      client
        .updateContact(data as ISingleClientContact)
        .then(() => {
          ui.modal?.resolve?.(data)
        })
        .catch(e => console.log(e))
    },
    [ui.modal]
  )

  const handleSubmit = () => form.handleSubmit(onSubmitCallBack)()
  const FormInput = OvFormInput<ISingleClientContact>

  return (
    <OvFormProvider
      form={form}
      onSubmit={handleSubmit}>
      <OvForm>
        <Stack
          direction="column"
          spacing={2}>
          <FormInput
            name="first_name"
            label="Voornaam"
          />
          <FormInput
            name="last_name"
            label="Achternaam"
          />
          <FormInput
            name="email"
            label="E-mail"
            placeholder={PLACEHOLDERS.EMAIL}
          />
          <FormInput
            name="phone"
            label="Telefoonnummer"
            placeholder={PLACEHOLDERS.PHONE}
            helperText={HELPER_TEXT.PHONE}
          />
          <FormInput
            name="department"
            label="Afdeling"
          />
          <Stack
            direction="row"
            spacing={2}>
            <Tooltip title={TOOLTIPS.CANCEL_CONTACT_UPDATE}>
              <Button
                onClick={() => ui.modal.reject?.()}
                variant="outlined">
                Annuleren
              </Button>
            </Tooltip>
            <Tooltip title={TOOLTIPS.SAVE_CONTACT_UPDATE}>
              <Button
                onClick={handleSubmit}
                variant="contained">
                Opslaan
              </Button>
            </Tooltip>
          </Stack>
        </Stack>
      </OvForm>
    </OvFormProvider>
  )
})
